import { createFileRoute, Outlet } from '@tanstack/react-router';
import styled from 'styled-components';
import { GroupSidebar } from '../../modules/sidebar/GroupSidebar';

export const Route = createFileRoute('/_app/_dashboard/groups')({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Container>
      <GroupSidebar />
      <PageContent>
        <Outlet />
      </PageContent>
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  min-height: 70vh;

  @media (max-width: 1099px) {
    flex-direction: column;
  }
`;

const PageContent = styled.div`
  flex: 1;
  max-width: calc(100% - 296px);
  padding: 14px 0 50px 50px;

  @media (max-width: 1099px) {
    max-width: 100%;
    padding: 14px 16px 50px;
  }
`;
